import React, { Component } from 'react'
import { Trans, withI18n, withI18nProps } from '@lingui/react'
import SVGInline from 'react-svg-inline'
import { push } from 'react-router-redux'
import compose from 'lodash/fp/compose'
import cn from 'classnames'

import urlFor from 'shared/tools/url-helper'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import Spacer from 'client/shared/blocks/spacer'
import { LayoutColumn } from 'client/shared/blocks/layout-column'
import PlanOption from 'client/shared/blocks/plan-option'
import Button from 'client/shared/blocks/button'
import { Details } from 'client/shared/blocks/details'

import NextIcon from 'client/shared/icons/next.svg'
import { changePlan, GiftPlan } from 'client/bookmate/reducers/gifts-reducer'
import { TRANSLATIONS } from 'client/bookmate/boxes/gifts-index-box'
import { GiftsHead } from './gifts-head'

import './gifts.styl'
import { Heading } from 'client/shared/blocks/heading/heading'
import { Locale } from 'client/shared/types/current-user'
import subscriptionHelper from 'client/shared/helpers/subscription-helper'
import { Event } from 'client/shared/types/event'

type Props = {
  isAudioAvailable: boolean
  areComicsAvailable: boolean
  kind: 'premium' | 'audio'
  locale: Locale
  userCountry: string
  plans: GiftPlan[]
  currentPlan?: GiftPlan
  currentPlanId?: string
} & DecoratorProps &
  withI18nProps

class _Gifts extends Component<Props> {
  onPlanSelection = (event: Event): void => {
    event.preventDefault()

    const { dispatch } = this.props
    const selectedPlanId =
      event.target?.dataset?.planId || event.currentTarget?.dataset?.planId

    dispatch(changePlan(selectedPlanId))
    dispatch(push(urlFor.giftsCustomisation()))
  }

  getLayoutColumnProps = () => {
    const { isMobileOS, isMobileSize, isTabletSize } = this.props

    return isMobileOS() || isMobileSize() || isTabletSize()
      ? {}
      : {
          size: 12,
          centered: true,
        }
  }

  filterPlansBySystem() {
    const { plans } = this.props
    return plans?.filter(plan => subscriptionHelper.isCardsPlan(plan))
  }

  render(): JSX.Element {
    const {
      isMobileOS,
      isMobileSize,
      isTabletSize,
      userCountry,
      i18n,
    } = this.props
    const isMobile = isMobileOS() || isMobileSize() || isTabletSize()
    const layoutColumnProps = this.getLayoutColumnProps()
    const plans = this.filterPlansBySystem()

    return (
      <div className="gifts">
        <LayoutColumn {...layoutColumnProps}>
          <GiftsHead userCountry={userCountry} isMobileSize={isMobileSize()} />
          <div
            className={cn('gifts__plan-list', {
              list__column: isMobileOS(),
            })}
          >
            {plans.map(plan => {
              return isMobile ? (
                <button
                  className="gifts__plan"
                  onClick={this.onPlanSelection}
                  data-plan-id={plan.id}
                  key={plan.id}
                  aria-label={i18n.t`header.buy_subscription_link`}
                >
                  <PlanOption plan={plan} hideBadge />
                  <SVGInline svg={NextIcon} />
                </button>
              ) : (
                <div className="gifts__plan" key={plan.id}>
                  <PlanOption plan={plan} hideBadge />
                  <Button
                    width="250px"
                    type="inline"
                    aria-label={i18n.t`header.buy_subscription_link`}
                    onClick={this.onPlanSelection}
                    data-plan-id={plan.id}
                  >
                    <Trans id="gifts.button_choose" />
                  </Button>
                </div>
              )
            })}
          </div>
          <Spacer size={isMobileSize() ? 32 : 56} />
          <Heading kind="graphik" rank={isMobileSize() ? 3 : 2} centered>
            <Trans id="gifts.frequently_asked_questions" />
          </Heading>
          <Spacer size={isMobileSize() ? 24 : 32} />
          {TRANSLATIONS.map(item => (
            <Details element={item} namespace="gifts" mode="details_dark" />
          ))}
        </LayoutColumn>
      </div>
    )
  }
}

const wrappers = compose(uiBox, withI18n({ update: true }))

export const Gifts = wrappers(_Gifts)
